import routes from './routes'
import { Fetch } from '../fetch'

/**
 * This services are for make the requests related to the Locations functionality
 */
class LocationsService {
  async fetchLocations (payload) {
    return Fetch('get', routes.LOCATIONS(payload))
  }
}

export default new LocationsService()
